import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxCollapse  from './components/vx-collapse/VxCollapse.vue'
import VxCollapseItem  from './components/vx-collapse/VxCollapseItem.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import DateRangePicker  from './components/DateRangePicker.vue';
import VueFormWizard from 'vue-form-wizard'
import VueLodash from 'vue-lodash'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueTheMask from 'vue-the-mask';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBarcode, faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faBarcode);

Vue.use(VueFormWizard)
Vue.use(VueTheMask)
Vue.use(VueLodash, {name:'_.'})
Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(VxCollapse.name, VxCollapse);
Vue.component(VxCollapseItem.name, VxCollapseItem);
Vue.component(VxBreadcrumb.name, VxBreadcrumb);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(DateRangePicker.name, DateRangePicker);
Vue.component('font-awesome-icon', FontAwesomeIcon);
